module.exports = __webpack_public_path__ + "static/media/garbage-2-white.1d6a6030.svg";